var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLinkify)?_c('p',{staticClass:"v-resume-text",class:[
		`v-resume-text--${_vm.color}`,
		_vm.miniSize ? 'v-resume-text--mini' : ''
	]},[_vm._v("\n\t"+_vm._s(_vm.text)+"\n")]):_c('p',{staticClass:"v-resume-text",class:[
		`v-resume-text--${_vm.color}`,
		_vm.miniSize ? 'v-resume-text--mini' : ''
	],domProps:{"innerHTML":_vm._s(_vm.linkify(_vm.text))}})
}
var staticRenderFns = []

export { render, staticRenderFns }